const DELAY_MILLIS_DEFAULT = 1000;

/**
 * Keeps the timeout by an identical callback function
 * @type {{}}
 */
const TIMEOUTS_BY_FUNCTION = {};


/**
 * Executes the given function after the provided delay. Multiple calls prior to the callout will extend the delay to
 * ensure a one-time execution after the given delay.
 *
 * @param deferredCallback {function} Function to call after the delay
 * @param delayMillis {number} Delay in milliseconds, defaults to 1000
 * @param timeoutId {string|null} Optional identifier for the timeout
 */
function useTimeout(deferredCallback, delayMillis = DELAY_MILLIS_DEFAULT, timeoutId = null) {

    const resolvedTimeoutId = timeoutId || deferredCallback;
    let timeout = TIMEOUTS_BY_FUNCTION[resolvedTimeoutId];

    if (timeout) {
        window.clearTimeout(timeout);
    }

    timeout = window.setTimeout(deferredCallback, delayMillis);
    TIMEOUTS_BY_FUNCTION[resolvedTimeoutId] = timeout;

    return {
        clear: () => {
            if (timeout) {
                window.clearTimeout(timeout);
            }
        }
    };
}


export default useTimeout;
